module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.isActive
    },
    attrs: {
      "data-target": "navMenubd-example"
    },
    on: {
      "click": _vm.toggleClass
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.isActive
    },
    attrs: {
      "id": "navMenubd-example"
    }
  }, [_c('a', {
    staticClass: "navbar-item is-white",
    attrs: {
      "href": "/transactions"
    }
  }, [_vm._v("\n      Transactions\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item is-white",
    attrs: {
      "href": "/users"
    }
  }, [_vm._v("\n      Users\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item is-white",
    attrs: {
      "href": "/d/users"
    }
  }, [_vm._v("\n      D Users\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item is-white",
    attrs: {
      "href": "/d/batches"
    }
  }, [_vm._v("\n      Batches\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item is-white",
    attrs: {
      "href": "/d/payments"
    }
  }, [_vm._v("\n      Payments\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item is-white",
    attrs: {
      "href": "/dispense"
    }
  }, [_vm._v("\n      Dispense Electricity\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item is-white is-hidden-desktop",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n      Logout\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-end is-hidden-mobile"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('span', [_vm._v("Logout")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-item is-logo",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/_logo.png",
      "alt": "Biya Support",
      "height": "40"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fee8d0c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomHeader.vue
// module id = 256
// module chunks = 1